import { useMemo } from 'react';
import { useIndexEventsWidgetData } from '../../hooks/useIndexEventsWidgetData';
import { IndexRebalanceEvent } from '../../api/IndexEventsResponse';

export function useIndexEventsGridData(): IndexRebalanceEvent[] {
    const data = useIndexEventsWidgetData();

    return useMemo(() => {
        return data?.response?.indexRebalEvents ?? [];
    }, [data]);
}
